import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { User } from '../models/user.model';
import { ApiService } from '../http/api.service';

@Injectable({ providedIn: 'root' })
export class UserService {
  private BACKEND_URL: string;
  private HEADERS: any;

  constructor(
    private http: HttpClient,
    private apiService: ApiService,
  ) {
    this.HEADERS = this.apiService.HEADERS;
    this.BACKEND_URL = this.apiService.BACKEND_URL;
  }

  async getAllUsersByCompanie(idCompanie: string) {
    return await this.http.get<User[]>(
      `${this.BACKEND_URL}/v1/user/users-by-company/${idCompanie}`
    ).toPromise();
  }

  async getAllUsers() {
    return await this.http.get<User[]>(
      `${this.BACKEND_URL}/v1/user`,
      { headers: this.HEADERS }
    ).toPromise();
  }

  async addCompanyOnUser(idUser: string, idCompany: string) {
    return await this.http.put(
      `${this.BACKEND_URL}/v1/user/addCompany/${idUser}/${idCompany}`,
      { headers: this.HEADERS }
    ).toPromise();
  }

  async removeCompanyOnUser(idUser: string, idCompany: string) {
    return await this.http.delete(
      `${this.BACKEND_URL}/v1/user/removeCompany/${idUser}/${idCompany}`,
      { headers: this.HEADERS }
    ).toPromise();
  }

  async addHoldingOnUser(idUser: string, idHolding: string) {
    return await this.http.put(
      `${this.BACKEND_URL}/v1/user/addHolding/${idUser}/${idHolding}`,
      { headers: this.HEADERS }
    ).toPromise();
  }

  async removeHoldingOnUser(idUser: string, idHolding: string) {
    return await this.http.delete(
      `${this.BACKEND_URL}/v1/user/removeHolding/${idUser}/${idHolding}`,
      { headers: this.HEADERS }
    ).toPromise();
  }

  async createUser(object: any) {
    return await this.http.post<any>(
      this.BACKEND_URL + '/v1/user/create',
      object,
      { headers: this.HEADERS }
    ).toPromise();
  }

  async createUserWithCompany(object: any) {
    return await this.http.post<any>(
      this.BACKEND_URL + '/v1/user/create-with-company',
      object,
      { headers: this.HEADERS }
    ).toPromise();
  }

  async updateUser(object, idUser: string) {
    return await this.http.put<any>(
      `${this.BACKEND_URL}/v1/user/${idUser}`,
      object,
      { headers: this.HEADERS }
    ).toPromise();
  }

  async deleteUser(idUser: string) {
    try {
      await this.http.delete(
        `${this.BACKEND_URL}/v1/user/${idUser}`,
        { headers: this.HEADERS }
      ).toPromise();
      
      return {
        error: false,
        message: 'Usuário excluído com sucesso'
      };
    } catch (error) {
      
      if (error instanceof HttpErrorResponse) {
        // A mensagem vem diretamente no error.error como string
        return {
          error: true,
          message: error.error
        };
      }

      return {
        error: true,
        message: error
      };
    }
  }

  /**
   * Trazer o Usuário de acordo com o id da URL
   * caso tela seja acessada remotamente
   */
  async getUser(id: string): Promise<User> {
    const response = await this.getAllUsers();
    const user = response.filter(user => user.id === id);
    return user[0];
  }
}
